<template>
    <div class="pop-up-overlay" v-if="dialogTableVisible" @click.self="close">
        <div class="pop-up-container">
            <div class="close">
                <img src="../../assets/code-close.png" @click="close" style="width: 26px; height: 26px;"  class="close-img"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PopUp',
    data() {
        return {
            dialogTableVisible: false
        }
    },
    methods: {
        close() {
            this.dialogTableVisible = false;
        },
        open(){
             this.dialogTableVisible = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.pop-up-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.pop-up-container {
    height: 523px;
    width: 480px;
    background-image: url('../../assets/saoma.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .close{
        width: 469px;
        height: 37px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/PopUp/popUp.vue